import Loadable from '../../components/loadable';

const CopyOnlineMeetingsModal = Loadable({
  loader: () => import('../../pages/calendar/copy_online_meetings_modal'),
});

angular.module('shared').value('CopyOnlineMeetingsModal', CopyOnlineMeetingsModal);
